/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Basket = 'Website.MiniBasket.Basket';
export const Headline = 'Website.MiniBasket.Headline';
